<template>
	<PopupRouterViewDetail label="Version Notification Detail" @hideMethod="onHidden" :isShowCopyData="false">
		<b-card header="Version Notification" class="mb-3 card-max-width">
			<b-row>
				<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="platformOptions" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Platform" id="fieldset-platform" size="sm" :model.sync="model.platform" :selected="model.platform" :isRequired="true" :state="validateState('platform')" :errorMessage="getErrorMessage(errorMessage.platform, 'platform')" @change="updateData" :isUpdatable="true" :isSelectMethodExists="true" @onSelectMethod="setSelectedPlatform" :preloadOnMount="false" />
					<app-input-textbox id="version" label-cols-lg="12" label="Version" label-for="input-version" size="sm" :model.sync="model.version" maxLength="50" :isRequired="true" :state="validateState('version')" :errorMessage="getErrorMessage(errorMessage.version, 'version')" @change="updateData" :isUpdatable="true" />
					<app-input-combobox-autocomplete :options="modeOptions" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Mode" id="fieldset-mode" size="sm" :model.sync="model.mode" :selected="model.mode" :isRequired="true" :state="validateState('mode')" :errorMessage="getErrorMessage(errorMessage.mode, 'mode')" @change="updateData" :isUpdatable="true" :isSelectMethodExists="true" @onSelectMethod="setSelectedMode" :preloadOnMount="false" />
					<app-input-textbox id="title-notification" label-cols-lg="12" label="Title Notification" label-for="input-title-notification" size="sm" :model.sync="model.titleNotification" maxLength="200" @change="updateData" :isUpdatable="true" />
					<app-input-textarea id="message-notification" label-cols-lg="12" label="Message Notification" label-for="input-message-notification" size="sm" :model.sync="model.messageNotification" maxLength="1000" @change="updateData" :isUpdatable="true" />
				</b-col>
				<b-col cols="12" lg="6">
					<app-input-textbox id="appstore-url-label" label-cols-lg="12" label="App Store Url" label-for="input-appstore-url-label" size="sm" :model.sync="model.appStoreUrl" maxLength="2000" @change="updateData" :isUpdatable="true" />
					<app-input-textbox id="playstore-url-label" label-cols-lg="12" label="Play Store Url" label-for="input-playstore-url-label" size="sm" :model.sync="model.playStoreUrl" maxLength="2000" @change="updateData" :isUpdatable="true" />
					
					<app-input-textbox id="store-button-label" label-cols-lg="12" label="Store Button Label" label-for="input-store-button-label" size="sm" :model.sync="model.storeButtonLabel" maxLength="100" @change="updateData" :isUpdatable="true" />
					<app-input-textbox id="dismiss-button-label" label-cols-lg="12" label="Dismiss Button Label" label-for="input-dismiss-button-label" size="sm" :model.sync="model.dismissButtonLabel" maxLength="100" @change="updateData" :isUpdatable="true" />
					<app-input-textbox id="close-button-label" label-cols-lg="12" label="Close Button Label" label-for="input-close-button-label" size="sm" :model.sync="model.closeButtonLabel" maxLength="100" @change="updateData" :isUpdatable="true" />
				</b-col>
			</b-row>
		</b-card>

		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</PopupRouterViewDetail>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import VersionNotification from '@/models/VersionNotification/VersionNotification';
import VersionNotificationFilter from '@/filters/VersionNotification/VersionNotificationFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';

export default {
	components : {
		AppInputTextbox,
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		PopupRouterViewDetail,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			platform: {required},
			version: {required},
			mode: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				platform: { required : "Platform is Required."},
				version: { required : "Version is Required."},
				mode: { required : "Mode is Required."},
			},
			isBusy: false,
			modelId: null,
			model: {},
			filterVersionNotification : null,
			mainRecordId : '',
			platformOptions: [
				{ id: 'iOS', name: 'iOS' },
				{ id: 'android', name: 'android' },
			],
			modeOptions: [
				{ id: 'Mandatory', name: 'Mandatory' },
				{ id: 'Optional', name: 'Optional' },
				{ id: 'Expired', name: 'Expired' },
			],
		}
	},
	methods : {
		getVersionNotification : async function(id) {
			this.isBusy = true;
			VersionNotification.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId || result.id);
				this.isBusy = false;
			}).catch(() => { this.isBusy = false; });
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		setSelectedPlatform(item) {
			this.model.platform = item != null ? item.id : null;
			this.$forceUpdate();
			this.updateData();
		},
		setSelectedMode(item) {
			this.model.mode = item != null ? item.id : null;
			this.$forceUpdate();
			this.updateData();
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			this.$v.model.$touch();
			if (this.$v.model.$anyError) {
				return;
			}
			if (id != '' && id != null && id != undefined) {
				this.isBusy = true;
				VersionNotification.updateDataDetail(this, model, id)
				.then(() => {
					this.isBusy = false;
				})
				.catch(() => {
					this.isBusy = false;
					this.getVersionNotification(id);
				});
			}
		},
		onHidden() {
			this.$router.push({ name: 'versionnotificationindex' });
		},
	},
	beforeMount() {
		this.model = new VersionNotification();
		this.filterVersionNotification = new VersionNotificationFilter();
	},
	mounted(){
		let id = this.$route.params.id;
		if (id != '' && id != null && id != undefined) {
			this.modelId = id;
			this.getVersionNotification(id);
		}
	},
	watch : {
		'$route.params.id': function(id) {
			if (id != '' && id != null && id != undefined) {
				this.modelId = id;
				this.getVersionNotification(id);
			}
		},
	},
}
</script>
